<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew bg-gradient-warning bg-image-treek">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-7">
                <h1 class="display-3 text-white">{{ $t('nav.references.title') }}</h1>
                <p class="lead  text-white">{{ $t('nav.references.header') }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="section section-lg">
      <div class="container">
        <div class="row justify-content-center text-center mb-lg">
          <div class="col-lg-8">
            <h2 class="display-3">{{ $t('references.title') }}</h2>
            <p class="lead text-muted">{{ $t('references.para1') }}</p>
          </div>
        </div>
        <div v-for="referenceGroup in groupedReferences" v-bind:key="referenceGroup.id"
             class="row row-grid">
          <div v-for="reference in referenceGroup" v-bind:key="reference.id"
               class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <a :href="'/reference/'+reference.slug">
                <img v-lazy="reference.src"
                     class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                     style="width: 200px;">
                <div class="pt-4 text-center">
                  <h5 class="title">
                    <span class="d-block mb-1">{{ reference.name }}</span>
                    <span class="lead text-muted">{{ reference.role }}</span><br/>
                    <span class="lead text-muted">{{ reference.company }}</span>
                  </h5>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import referencesData from '../data/references.js';
  import listUtils from "../lib/listUtils";

  export default {
    name: "references",
    components: {},
    data() {
      return {
        references: referencesData
      }
    },
    computed: {
      groupedReferences() {
        return listUtils.group(listUtils.sortById(this.references))
      }
    }
  };
</script>
